import { pathSelector } from 'redux/saga/selectors';
import { cms } from 'redux/saga/entities/bound';

export const selectCmsPath = state => {
  const path = pathSelector(state);
  return cms.defaultKey(null, path);
};
